import { Controller } from "@hotwired/stimulus";

export class DropdownMenuController extends Controller {
  static targets = ["menu"];

  static values = {
    position: { type: String, default: "bottom" },
  };

  toggle(event) {
    event.stopPropagation();
    this.element.classList.toggle("dropdown--open");
    this.applyPosition();
  }

  connect() {
    this.closeOnOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener("click", this.closeOnOutsideClick);
    this.applyPosition();
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick);
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.element.classList.remove("dropdown--open");
    }
  }

  applyPosition() {
    const positions = [
      "bottom",
      "top",
      "left",
      "right",
      "bottom-center",
      "top-center",
    ];

    positions.forEach((pos) => {
      this.element.classList.remove(`dropdown--${pos}`);
    });

    this.element.classList.add(`dropdown--${this.positionValue}`);
  }
}
